import { useLocation } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
function useQueryParams<Params extends { [K in keyof Params]?: string } = {}>(): Params {
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);

  const params: any = {};
  queryParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
}

export default useQueryParams;
